'use client';

/**
 * Subscribe a component to the own-auth JWT.
 *
 * Returns the current token (or null if signed out).  Re-renders the
 * component when the token changes via setAuthToken / clearAuthToken.
 */
import { useSyncExternalStore } from 'react';

import { getAuthToken, subscribeAuthToken } from './store';

export function useAuthToken(): string | null {
  return useSyncExternalStore(subscribeAuthToken, getAuthToken, () => null);
}
